import React, {useEffect} from 'react';
import { Box } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import RegistrationCodeBox from './registration-code-box';
import RegistrationBox from './registration-box';
import LoginButtonGroup from '../shared/login-button-group';
import NotificationBar from '../shared/notification-bar';

const Registration = ({
  match,
  handleRegistrationCodeChange,
  handleFirstNameChange,
  handleLastNameChange,
  handleEmailChange,
  handlePasswordChange,
  handlePasswordConfirmationChange,
  handleProfessionChange,
  handleRegistrationCodeSubmit,
  handleRegistrationSubmit,
  legalChecked,
  toggleLegalChecked,
  errorMessage,
  successMessage,
  pharmacy,
  passwordMatch,
  handleGenderChange,
  gender,
  professions,
  professionId,
}) => {
  useEffect(() => {
    const wrapper = document.querySelector('.scrollable');
    if (!wrapper) return;

    document.querySelector('.scrollable').addEventListener(
      'touchmove',
      function(event) {
        event.stopPropagation();
      },
      false,
    );
  });

  return (
    <div className="scrollable">
        {(successMessage || errorMessage) && (
          <NotificationBar
            successMessage={successMessage}
            errorMessage={errorMessage}
          />
        )}
          {!pharmacy && (
            <>
            <div className="login">
              <LoginButtonGroup isRegistration={true} />
              <RegistrationCodeBox
                handleRegistrationCodeSubmit={handleRegistrationCodeSubmit}
                handleRegistrationCodeChange={handleRegistrationCodeChange}
              />
            </div>
            </>
          )}
          {pharmacy && (
            <RegistrationBox
              handleFirstNameChange={handleFirstNameChange}
              handleLastNameChange={handleLastNameChange}
              handleEmailChange={handleEmailChange}
              handlePasswordChange={handlePasswordChange}
              passwordMatch={passwordMatch}
              legalChecked={legalChecked}
              toggleLegalChecked={toggleLegalChecked}
              handleRegistrationSubmit={handleRegistrationSubmit}
              handlePasswordConfirmationChange={
                handlePasswordConfirmationChange
              }
              handleGenderChange={handleGenderChange}
              handleProfessionChange={handleProfessionChange}
              gender={gender}
              professions={professions}
              professionId={professionId}
            />
          )}
    </div>
  );
};

export default Registration;
